<template>
  <dropdown
    v-bind="dropdownProps"
    v-model="open">
    <a
      role="combobox"
      :aria-controls="domAttributes.id"
      v-bind="buttonProps"
      v-tooltip.hover.top.unenterable="buttonProps.tooltipText"
      @keydown="handleDropdownKeydown"
      @focus="$emit('focusedDropdownButton')"
      @click="$emit('openedDropdown', open)"
      :aria-expanded="open ? 'true' : 'false'"
      tabindex="0">
      <slot name="button-contents" />
    </a>
    <template slot="dropdown">
      <slot name="dropdown-items" />
    </template>
  </dropdown>
</template>

<script>
import { tooltip } from 'uiv'

export default {
  name: 'A11yDropdown',
  directives: { tooltip },
  data() {
    return {
      open: false
    }
  },
  props: {
    dropdownProps: {type: Object, default: null},
    buttonProps: {type: Object, default: null},
    domAttributes: {type: Object, default: null}
  },
  methods: {
    setDomAttributes() {
      if (this.domAttributes) {
        for (const [key, val] of Object.entries(this.domAttributes)) {
          // get the ref from the dropdownProps which refers to the uiv dropdown component which itself has a ref called dropdown which is the ul for the dropdown menu
          this.$refs?.[this.dropdownProps?.ref]?.$refs?.dropdown?.setAttribute(key, val)
        }
      }
    },
    handleDropdownKeydown(event) {
      const keys = ['Enter', ' ', 'ArrowDown']
      if (keys.includes(event.key)) {
        event.preventDefault()
        this.handleOpenDropdown(event.key)
      }
    },
    handleOpenDropdown(key) {
      if (!this.open || key !== 'ArrowDown') {
        this.$emit('openedDropdown', open)
        this.$refs[this.dropdownProps.ref].toggle()
      }
    }
  },
  mounted() {
    this.setDomAttributes()
  },
  watch: {
    domAttributes() {
      this.setDomAttributes()
    }
  }
}
</script>
